import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { iReference } from "../state/Reference";
import { Unknown } from "../Status";

export function setNodeLocationToRemote(node: api_cs.Cnode): void {
	const was_local = node.properties.location.switch({ local: true, remote: false });
	node.properties.location.ensure("remote", {
		"edit mode": ["off", {}],
	});
	for (const attribute of node.properties.attributes.values()) {
		const type = attribute.properties.type.state;
		switch (type.name) {
			case "operation":
				break;
			case "property": {
				const property_type = type.node.properties.type.state;
				switch (property_type.name) {
					case "text":
						switch (property_type.node.properties.is_key.state.name) {
							case "yes": {
								const value = property_type.node.properties.is_set.switch({
									no: () => "",
									yes: ($) => $.properties.text,
								});
								property_type.node.properties.backend_known.ensure("yes", { value: value }).set_value(value);
								break;
							}
							case "no":
								switch (property_type.node.properties.is_set.state.name) {
									case "no":
										break;
									case "yes":
										switch (property_type.node.properties.backend_known.state.name) {
											case "no": {
												const modified = property_type.node.properties.is_editable.switch({
													no: () => false,
													yes: ($) =>
														$.properties.modified.switch({
															no: false,
															yes: true,
														}),
												});
												if (!modified) {
													property_type.node.properties.is_set.set("no", {});
												}
												break;
											}
											case "yes":
												break;
										}
										break;
								}
								break;
						}
						break;
					case "number":
						break;
					case "file":
						break;
					case "group":
						setNodeLocationToRemote(property_type.node.properties.node);
						break;
					case "state group": {
						const is_set = property_type.node.properties.is_set.state;
						switch (is_set.name) {
							case "no":
								break;
							case "yes":
								is_set.node.properties.state.ref.properties.location.ensure("remote", {});
								setNodeLocationToRemote(is_set.node.properties.state.ref.properties.node);
								break;
						}
						break;
					}
					case "collection":
						if (was_local) {
							setCollectionLocationToRemote(property_type.node);
						}
						break;
				}
				break;
			}
		}
	}
}

function setNodeLocationToLocal(
	node: api_cs.Cnode,
	parent_location: api_cs.Tlocal__location__node["parent location"]
): void {
	node.properties.location.ensure("local", {
		"parent location": parent_location,
	});
	for (const attribute of node.properties.attributes.values()) {
		switch (attribute.properties.type.state.name) {
			case "operation":
				break;
			case "property": {
				const property = attribute.properties.type.state.node;
				switch (property.properties.type.state.name) {
					case "text": {
						const text = property.properties.type.state.node;
						text.properties.backend_known.set("no", {});
						text.properties.navigable.switch({
							no: () => undefined,
							yes: (reference) => iReference(reference).setServerValue(Unknown),
						});
						break;
					}
					case "number": {
						const number = property.properties.type.state.node;
						number.properties.backend_known.set("no", {});
						break;
					}
					case "file": {
						const file = property.properties.type.state.node;
						file.properties.backend_known.set("no", {});
						break;
					}
					case "group": {
						const group = property.properties.type.state.node;
						setNodeLocationToLocal(group.properties.node, parent_location);
						break;
					}
					case "state group": {
						const stategroup = property.properties.type.state.node;
						stategroup.properties.initialized.set("no", {});
						for (const state of stategroup.properties.states.values()) {
							setStateLocationToLocal(state);
						}
						break;
					}
					case "collection": {
						const collection = property.properties.type.state.node;
						for (const entry of collection.properties.entries.values()) {
							setEntryLocationToLocal(entry);
						}
						break;
					}
					default:
						unexpectedState(property.properties.type.state);
				}
				break;
			}
			default:
				unexpectedState(attribute.properties.type.state);
		}
	}
}

export function setStateLocationToLocal(state: api_cs.Cstates__state_group__type__property): void {
	const parent_location = state.parent.parent.parent.parent.properties.location.switch({
		local: ($) => $.properties.parent_location.state.name,
		remote: "remote",
	});
	state.properties.location.ensure("local", {});
	setNodeLocationToLocal(state.properties.node, parent_location);
}

export function setEntryLocationToRemote(entry: api_cs.Centries__collection): void {
	switch (entry.properties.location.state.name) {
		case "local":
			entry.properties.location.set("remote", {
				"marked for deletion": ["no", {}],
			});
			break;
		case "remote":
	}
	setNodeLocationToRemote(entry.properties.node);
}

function setCollectionLocationToRemote(collection: api_cs.Ccollection): void {
	for (const entry of collection.properties.entries.values()) {
		setEntryLocationToRemote(entry);
	}
}

function setEntryLocationToLocal(entry: api_cs.Centries__collection): void {
	entry.properties.location.ensure("local", {
		"modified by": ["engine", {}],
	});
	const parent_location = entry.parent.parent.parent.parent.properties.location.state.name;
	setNodeLocationToLocal(entry.properties.node, parent_location);
}

export function setNodeContextToLocal(node: api_cs.Cnode): void {
	const position = node.input.position();
	switch (position.variant.name) {
		case "root":
			setNodeLocationToLocal(node, "remote");
			break;
		case "group": {
			const $ = position.variant.definition;
			setNodeContextToLocal($.parent.parent.parent);
			break;
		}
		case "state": {
			const $ = position.variant.definition;
			setStateLocationToLocal($);
			break;
		}
		case "entity": {
			const $ = position.variant.definition;
			switch ($.variant.name) {
				case "entry": {
					const entry = $.variant.definition;
					setEntryLocationToLocal(entry);
					break;
				}
				case "root":
					setNodeLocationToLocal(node, "remote");
					break;
				default:
					unexpectedState($.variant);
			}
			break;
		}
		default:
			unexpectedState(position.variant);
	}
}
